export const getExtraMailDisabledState = () => {
  return {
    isObjectDisabled: false,
    isBodyDisabled: false
  };
};
